import React, { Component } from 'react'
import { useFormikContext, ErrorMessage } from 'formik'
import { connect } from 'react-redux'

import { getGroupedCountries } from 'SRC/modules/geoObjects/countries/selectors'
import { fetchCitiesByCountryWithinRegions } from 'SRC/modules/geoObjects/cities/actions'

import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

const Country = ({
  countries,
  fetchCitiesByCountryWithinRegions
}) => {
  const formik = useFormikContext()

  const selectedCountry = formik.values.newUser ? formik.values.newUser.country : -1

  React.useEffect(() => {
    fetchCitiesByCountryWithinRegions(Number(selectedCountry))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCountry])

  const [countryState, setCountryState] = React.useState({
    country: formik.values && formik.values.newUser ? formik.values.newUser.country : -1,
    dial: formik.values && formik.values.newUser ? formik.values.newUser.dial : ''
  })

  const countryOptions = Array.isArray(countries)
    ? countries.map(country => ({
			id: `${country.id}`,
			label: country.label,
			value: JSON.stringify({
        country: `${country.id}`,
        dial: `${country.dial}`
      }),
			isGrouped: country.isGrouped,
			options: Array.isArray(country.options)
        ? country.options.map(childCountry => ({
          id: `${childCountry.id}`,
          label: childCountry.label,
          value: JSON.stringify({
            country: `${childCountry.id}`,
            dial: `${childCountry.dial}`
          }),
        }))
        : []
		}))
    : []

  let countryError = ''

  if (formik.touched.newUser && formik.touched.newUser.country) {
    countryError = formik.errors.newUser && formik.errors.newUser.country
  }

  return (
    <Wrapper isError={!!countryError}>
      <SelectDropdown
        id='newUser_country'
        title='Država'
        isDisabled={false}
        isSearchable
        isRequired
        value={JSON.stringify(countryState)}
        options={countryOptions}
        onChange={async value => {
          let parsedValue = -1

          try {
            parsedValue = JSON.parse(value)

            console.log('parsedValue', parsedValue)

            if (Number(parsedValue.country) === -1) setCountryState({ country: -1, dial: '' })
            else setCountryState(parsedValue)
            
            await formik.setFieldValue('newUser.country', parsedValue.country)

            if (!formik.touched.newUser || !formik.touched.newUser.country) {
              formik.setFieldTouched(`newUser.country`, true)
            }

            formik.setFieldValue('newUser.city', -1)
            formik.setFieldValue('newUser.location', -1)
            formik.setFieldValue('newUser.dial', parsedValue.dial)
          } catch (err) {
            await formik.setFieldValue('newUser.country', -1)

            if (!formik.touched.newUser || !formik.touched.newUser.country) {
            	formik.setFieldTouched(`newUser.country`, true)
            }

            formik.setFieldValue('newUser.city', -1)
            formik.setFieldValue('newUser.location', -1)
            formik.setFieldValue('newUser.dial', '')

            setCountryState({ country: -1, dial: '' })
          }
    		}}
      />

      <ErrorMessage
        name='newUser.country'
        render={msg => <span style={{ display: 'block', marginTop: 5 }} className='form-group__error-message'>{msg}</span>}
      />
    </Wrapper>
  )
}

Country.displayName = 'Country'

const mapStateToProps = state => ({
  countries: getGroupedCountries(state)
})

export default connect(mapStateToProps, { fetchCitiesByCountryWithinRegions })(Country)
